import { AxiosResponse } from "axios"
import ConnectApi from "../../baseService"
import { TApiResponse } from "../../TApiResponse"
import {
  TKyuzituListGetReq,
  TKyuzituListGetRes,
  TKyuzituListPutReq,
} from "./TKyuzitu"

/**
 * 休日に対するAPIリクエスト用サービス
 *
 * @export
 * @class KyuzituService
 * @extends {ConnectApi}
 */
export default class KyuzituService extends ConnectApi {
  /**
   * 休日 一覧取得
   *
   * @param {TKyuzituListGetReq} params
   * @memberof KyuzituService
   */
  getList = async (params: TKyuzituListGetReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TKyuzituListGetRes[]>> =
        await this.getInner(`/master/kyuzitu`, params)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 休日 全件取得
   *
   * @param {TKyuzituListGetReq} params
   * @memberof KyuzituService
   */
  getAll = async () => {
    try {
      const res: AxiosResponse<TApiResponse<TKyuzituListGetRes[]>> =
        await this.getInner(`/master/kyuzitu/list/all`, {})
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 休日 更新
   *
   * @param {TKyuzituListPutReq} data
   * @memberof KyuzituService
   */
  put = async (data: TKyuzituListPutReq[]) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
        `master/kyuzitu`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  //   /**
  //    * 単体取得
  //    *
  //    * @param {TMenuInfoGetReq} params
  //    * @param {(param: TApiResponse<TMenuInfoGetRes[]>) => any} resolve
  //    * @param {(param: TApiResponse<TMenuInfoGetRes[]>) => any} reject
  //    * @memberof MenuService
  //    */
  //   get = async (id: string | number) => {
  //     try {
  //       // const res: AxiosResponse<TApiResponse<TSyukkinboInfoGetRes[]>> =
  //       // await this.getInner(`/master/hinmei`, params)
  //       //return res.data
  //       if (id === "3") {
  //         // eslint-disable-next-line no-throw-literal
  //         throw "ERROR"
  //       }

  //       return {
  //         data: dummyData[0],
  //       }
  //       //TODO: api実装必要
  //     } catch (err) {
  //       throw err
  //     }
  //   }

  //   /**
  //    * 単体登録
  //    *
  //    * @param {TKyotenPostReq} data
  //    * @param {(param: TApiResponse<TKyotenRes>) => any} resolve
  //    * @param {(param: AxiosError<TApiResponse<TKyotenRes>>) => any} reject
  //    * @memberof KyotenService
  //    */
  //   post = async (data: TSyukkinboRegisterPostReq) => {
  //     try {
  //       const res: AxiosResponse<TApiResponse<boolean>> = await this.postInner(
  //         `master/hinmei/`,
  //         data
  //       )
  //       return res.data
  //     } catch (err) {
  //       throw err
  //     }
  //   }

  //   /**
  //    * 単体更新
  //    *
  //    * @param {TKyotenPostReq} data
  //    * @param {(param: TApiResponse<TKyotenRes>) => any} resolve
  //    * @param {(param: AxiosError<TApiResponse<TKyotenRes>>) => any} reject
  //    * @memberof KyotenService
  //    */
  //   put = async (id: string, data: TSyukkinboRegisterPostReq) => {
  //     try {
  //       const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
  //         `master/hinmei/${id}`,
  //         data
  //       )
  //       return res.data
  //     } catch (err) {
  //       throw err
  //     }
  //   }
}
